import { connectStaleableLoadable } from 'helpers/loadableHelpers'
import { Guards } from 'interfaces/guards'
import { memberInfoGuard } from 'guards/globalGuards'
import { showContactEditFormActionCreator } from 'actions/settingsActions'
import ContactSettingsModule, {
  ContactSettingsModuleStateProps,
  ContactSettingsModuleDispatchProps,
} from 'components/features/pfm/ContactSettingsModule/ContactSettingsModule'
import { isMemberDataPresentSelector, memberInfoSelector } from 'selectors/globalSelectors'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { createSelector } from 'reselect'
import { settingsSelector } from 'selectors/settingsSelector'

const createMapStateToProps = () => createSelector(
  memberInfoSelector,
  settingsSelector,
  (member, { contactEditFormVisible }): ContactSettingsModuleStateProps => {
    if (!member) {
      throw createForgottenGuardError('ContactSettingsModuleContainer', '')
    }

    const { email, contact_email, phone } = member

    // TODO somewhen get rid of ! here
    return {
      email: email!,
      contact_email: contact_email!,
      phone: phone!,
      contactEditFormVisible,
    }
  }
)

const mapDispatchToProps = {
  showContactEditForm: showContactEditFormActionCreator,
}

const guards: Guards<{}> = [
  memberInfoGuard,
]

export default connectStaleableLoadable<
  ContactSettingsModuleStateProps, ContactSettingsModuleDispatchProps
>(guards, isMemberDataPresentSelector)(createMapStateToProps, mapDispatchToProps)(ContactSettingsModule)
